import i18n from "i18next";
import { MouseEvent } from "react";
import BriaButton, { ButtonTypes } from "../BriaButton/BriaButton";

export type SurpriseTextsType =
	| "textToImage"
	| "textToImage2"
	| "textToImage32"
	| "textToVector"
	| "replaceBg"
	| "presentersStyle"
	| "fiboGenerate"
	| "fiboRefine";

export const getRandomText = (textsListType: SurpriseTextsType) => {
	const textList: string[] = Object.values(i18n.t(`surpriseMe.${textsListType}`, { returnObjects: true }));
	const randomNumber = Math.floor(Math.random() * textList.length);
	return textList[randomNumber];
};

type Props = {
	textsListType: SurpriseTextsType;
	onSurprise: (e: MouseEvent<HTMLButtonElement>, surpriseText: string) => void;
	buttonType?: ButtonTypes;
	buttonLabel?: string;
	className?: string;
};

const SurpriseButton = ({
	textsListType,
	onSurprise,
	buttonType = "textSmall",
	buttonLabel = i18n.t("surpriseMe.label"),
	className,
}: Props) => {
	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		onSurprise(e, getRandomText(textsListType));
	};

	return (
		<BriaButton className={className} buttonType={buttonType} onClick={handleClick}>
			{buttonLabel}
		</BriaButton>
	);
};

export default SurpriseButton;
